import Immutable from 'immutable';

export type ProjectDriveSyncStatusType =
  | 'SCHEDULED'
  | 'INPROGRESS'
  | 'COMPLETED'
  | 'UNKNOWN';

export interface RawProjectDriveSyncStatus {
  id: string;
  driveId: string;
  ownerId: string;
  providerType: string;
  createdAt?: string;
  scheduledAt?: string;
  startedAt?: string;
  completedAt?: string;
  status: ProjectDriveSyncStatusType;
  success?: boolean;
}

const defaultValues: RawProjectDriveSyncStatus = {
  id: '',
  driveId: '',
  ownerId: '',
  providerType: '',
  createdAt: undefined,
  scheduledAt: undefined,
  startedAt: undefined,
  completedAt: undefined,
  status: 'SCHEDULED',
  success: undefined,
};

export const ProjectDriveSyncStatusFactory = Immutable.Record(
  defaultValues,
  'ProjectDriveSyncStatus'
);

export class ProjectDriveSyncStatus extends ProjectDriveSyncStatusFactory {
  static deserialize(
    rawProjectDriveSyncStatus: RawProjectDriveSyncStatus
  ): ProjectDriveSyncStatus {
    return new ProjectDriveSyncStatus(rawProjectDriveSyncStatus);
  }

  serialize(): RawProjectDriveSyncStatus {
    return this.toJS();
  }

  hasFailed(): boolean {
    return this.status === 'COMPLETED' && this.success === false;
  }

  isActive(): boolean {
    return this.status === 'INPROGRESS' || this.status === 'SCHEDULED';
  }
}
